import styled from 'styled-components';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import { blue } from '@mui/material/colors';

export const ChooseButtonGroup = styled(ButtonGroup)`
  margin-bottom: 4px;
`;

export const ChooseLevelButton = styled(Button)`
  padding: 5px 15px !important;
`;

export const ChooseLevelOuter = styled.div`
  display: flex;
  justify-content: center;
`;

export const ChooseGameBox = styled.div`
  position: absolute;
  background-color: #999;
  top: 0; bottom: 0;
  left: 0; right: 0;
  z-index: 9;
  top: 0px;
  bottom: 0px;
  display: flex;
  z-index: 9999;
`;

export const ChooseGameInner = styled.div`
  padding: 5px;
  display: flex;
  flex: 1;
  flex-direction: row;
`;

export const Bomb = styled.i`
  margin-left: 2px;
`;

export const GameLevelName = styled.span`
  flex: 1;
`;

export const GameLevelSize = styled.span`
  width: 70px;
  text-align: center;
`;

export const GameLevelBombsCount = styled.span``;

export const ChooseButton = styled(Button)`
  display: flex !important;
  text-transform: none !important;
  width: 100%;
  margin-bottom: 10px !important;
  justify-content: space-between !important;
  text-align: left !important;
`;

export const ChooseGameGroupHeader = styled.div`
  background-color: #efefef;
  padding: 10px;
  text-align: center;
`;

export const ChooseGameGroupBox = styled(Paper)`
  border: 1px solid #eee;
  flex: 1;
  margin: 10px;
`;

export const ChooseGameButtonsBox = styled.div`
  padding: 10px;
`;

export const ProfileBox = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

export const ProfileName = styled.div`
  font-size: 14px;
  margin-left: 5px;
  display: flex;
  flex: 1;
`;

export const LastGamesBox = styled.div`

`;

export const GameRow = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  padding: 4px 6px;
  margin-bottom: 1px;
  background: #eee;
  & i {
    color: #1976d2;
    font-size: 14px;
  }
`;

export const UserNameBox = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
`;

export const UserName = styled.span``;

export const EditUserButton = styled.div`
  & i {
    font-size: 20px;
  }
`;

export const EditUserInput = styled.input``;

export const SavingLoadingBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0; bottom: 0;
  left: 0; right: 0;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
`;

export const BestAccordionBox = styled.div`
  padding: 0px;
  flex: 1;
`;

export const AccordionBox = styled.div`
  padding: 10px;
`;

export const TabsBox = styled.div`
  display: flex;
  justify-content: center;
  & .MuiButtonBase-root {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    font-size: 13px;
  }
  & .MuiButtonBase-root.Mui-selected {
    background: ${blue[500]} !important;
    color: #fff;
  }
`;

export const NoGamesBox = styled(Paper)`
  margin-left: 20px;
  margin-right: 20px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  background-color: #e0e0e0 !important;
`;

export const NoGameText = styled.div`
  font-size: 13px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 5px;
  padding-bottom: 5px;
`;

export const NoGameButton = styled(Button)`
  align-self: center;
`;